import React ,{useState , useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import loader from "../../assets/Images/loader.gif";
import { toast } from "react-toastify";

const EditMaterial = () => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchMaterialConsumptionCRM = async () => {
          try {
            setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData = {
                "Action": "getMaterialConsumptionCRM",
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "CanId": sessionStorage.getItem("CanId"),
                "Master": "false",
                "SrNumber": sessionStorage.getItem("ViewSR")
            }
            const response = await fetch(apiUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(requestData),
            });
            const result = await response.json();
            // console.log("getMaterialConsumptionCRM",result)
            if (result.Status === 1) {
              
            }
            else{
                toast.warning("No Data Found", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                  });
            }
          } catch (error) {
            console.error("Error fetching MaterialConsumptionCRM:", error);
          } finally {
            setLoading(false);
          }
        };
        fetchMaterialConsumptionCRM();
      }, []);

    const navigate = useNavigate();
  const redirectDashboardPage = () => {
    navigate("/dashboard");
  };
  return (
    <>
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectDashboardPage}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">SR Detail</span>
        </div>
      </div>


      {loading ? (
        <div className="loader-wrapper">
          <div className="loader">
            <img src={loader} alt="loading...."></img>
          </div>
        </div>
      ) : ( 
        <div>

        </div>
        )}
    </>
  )
}

export default EditMaterial;
